import { Box, Button } from '@mui/material';
import React, { useRef, useState } from 'react';

const Canvas = ({ setFirma, firma }) => {
    const canvasRef = useRef(null);
    const [drawing, setDrawing] = useState(false);
    const [lastPosition, setLastPosition] = useState({ x: 0, y: 0 });

    // Iniciar el dibujo
    const startDrawing = (e) => {
        const position = getPosition(e);
        setDrawing(true);
        setLastPosition(position);
    };

    // Detener el dibujo
    const stopDrawing = () => {
        setDrawing(false);
    };

    // Dibujar en el canvas
    const draw = (e) => {
        if (!drawing) return;
        const position = getPosition(e);
        const ctx = canvasRef.current.getContext('2d');

        ctx.beginPath();
        ctx.moveTo(lastPosition.x, lastPosition.y);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();

        setLastPosition(position);
    };

    // Obtener posición del mouse o tacto
    const getPosition = (e) => {
        let clientX; // Separar la declaración de clientX
        let clientY; // Separar la declaración de clientY

        // Detectar si es un evento táctil o de mouse
        if (e.touches) {
            // Si es táctil (usando el dedo o lápiz)
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        } else {
            // Si es un evento de mouse
            clientX = e.clientX;
            clientY = e.clientY;
        }

        const rect = canvasRef.current.getBoundingClientRect();
        const x = clientX - rect.left;
        const y = clientY - rect.top;
        return { x, y };
    };

    // Limpiar el canvas
    const clearCanvas = () => {
        const ctx = canvasRef.current.getContext('2d');
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    };

    // Guardar la firma como imagen
    const saveSignature = () => {
        const canvas = canvasRef.current;
        const dataURL = canvas.toDataURL();
        setFirma(dataURL)

    };

    return (
        <div style={{ display: "flex", alignItems: "center", "flexDirection": "column", padding: "10px" }}>
            <canvas
                ref={canvasRef}
                width="300px"
                height="200px"
                style={{ border: '1px solid black' }}
                onMouseDown={startDrawing}
                onMouseUp={stopDrawing}
                onMouseMove={draw}
                onTouchStart={startDrawing}
                onTouchMove={draw}
                onTouchEnd={stopDrawing}
            />
            {
                firma === null && <Box sx={{ mt: 2 }}>
                    <Button onClick={clearCanvas} variant="contained" color='secondary' fullWidth>Limpiar</Button>
                    <Button
                        sx={{ mt: 1 }}
                        onClick={saveSignature}
                        variant="contained"
                        color='primary'
                        fullWidth>Guardar Firma</Button>
                </Box>
            }


        </div>
    );
};

export default Canvas;
